module.exports = __webpack_public_path__ + "img/anchor.5068147a.png";